import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ScrollView } from "@dishopsaas/design-system";
import { getNewSections } from "../../ListProduct/ListProduct.services";
import { useAppSelector } from "../../../redux/hook";
import { styles } from "./ListSection.styles";
import { getColors } from "../../../utils";
import { useResponsive } from "../../../hooks/useResponsive";
export default function ListSection({ selectedSection, setSelectedSection }) {
  const { sections } = useSelector((state) => state.shopReducer);
  const { productOffers } = useAppSelector((state) => state.offerReducer);
  const { navbar, isMobile, navbarHeight, isHorizontalSection } = useSelector(
    (state) => state.componentReducer,
  );
  const [newSections, setNewSections] = useState([]);
  useResponsive();
  useEffect(() => {
    setNewSections(getNewSections(productOffers, sections));
  }, [sections, productOffers]);
  const scrollToSection = (sectionKey) => {
    const element = document.getElementById(`section-${sectionKey}`);
    if (element) {
      const offset = -4;
      window.scrollTo({
        top: element.offsetTop - offset,
        behavior: "smooth",
      });
    }
  };
  const handleSectionSelect = (sectionKey) => {
    setSelectedSection(sectionKey);
    scrollToSection(sectionKey);
  };

  const scrollViewItems = newSections
    .filter((section) => {
      return (
        section &&
        section.name &&
        typeof section.name === "string" &&
        section.name.trim() !== "" &&
        !section.hidden &&
        !section.isPrivate
      );
    })
    .map((section) => {
      const sectionName = section.name.trim();
      const sectionKey = section.key;

      return {
        ...section,
        value: sectionKey,
        title: sectionName,
        name: sectionName,
        image: section?.iconCompressedUrl || section.iconUrl,
        hidden: section.hidden || false,
        disabled: section.disabled || false,
      };
    });
  const isHorizontal = isHorizontalSection || isMobile;
  const { bgwhite } = getColors();
  const containerProps = isHorizontal
    ? {
        className: `d-block ${navbar ? "px-0 col-12" : ""}`,
        style: styles.horizontalContainer(bgwhite),
      }
    : {
        className: "sticky-top hide-scroll overflow-auto",
        style: styles.verticalContainer(navbarHeight),
      };

  const scrollViewProps = {
    key: selectedSection,
    items: scrollViewItems,
    value: selectedSection,
    onChange: handleSectionSelect,
    selectedSection: selectedSection,
    variant: "scrollable",
    showScrollbar: false,
    isLoading: scrollViewItems.length === 0,
    orientation: isHorizontal ? "horizontal" : "vertical",
    ...(isHorizontal
      ? {
          scrollButtons: true,
          allowScrollButtonsMobile: true,
          tabsSx: styles.horizontalTabsSx(isMobile),
        }
      : {
          scrollToIndex: undefined,
          topOffset: navbarHeight,
          sx: styles.scrollViewVertical,
        }),
  };

  return (
    <div {...containerProps}>
      <ScrollView {...scrollViewProps} />
    </div>
  );
}
